export class ApplicationError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        Object.setPrototypeOf(this, ApplicationError.prototype);
        this.name = 'ApplicationError';
    }
}
export class ApiError extends Error {
    statusCode;
    axiosError;
    errorInfo;
    constructor(message, axios, errorInfo) {
        super(message);
        Object.setPrototypeOf(this, ApiError.prototype);
        this.statusCode = axios?.response?.status ?? null;
        this.axiosError = axios ?? null;
        this.errorInfo = errorInfo ?? null;
    }
}
export class RateLimitError extends ApiError {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, RateLimitError.prototype);
    }
}
export class ServiceUnavailableError extends ApiError {
    constructor(axios, message = 'There is a temporary issue reaching our servers') {
        super(message, axios);
        Object.setPrototypeOf(this, ServiceUnavailableError.prototype);
    }
}
//# sourceMappingURL=errorModel.js.map